export default __webpack_public_path__ + "static/media/associated_accounts-img.9dd479cc.svg";